"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.getPlayableAds = getPlayableAds;
function getPlayableAds(adsConfig) {
  if (!adsConfig || !adsConfig.length) {
    return undefined;
  }
  var schedule = {};
  adsConfig.forEach(function (ad, index) {
    if (ad.type !== 'vmap') {
      schedule["ad".concat(index)] = {
        offset: ad.offset || 'pre',
        tag: ad.src
      };
    }
  });
  return schedule;
}
var _default = exports["default"] = {
  getPlayableAds: getPlayableAds
};